/* eslint-env browser */

import * as React from 'react'

require('../../container/client')

const ReactDOM = require('react-dom')
const DomHelper = require('../../client/clientjs/dom-helper')
const CountDown = require('../contest/components/CountDown')
const RankingTable = require('./components/RankingTable')
const IndividualRankingTable = require('./components/IndividualRankingTable')

DomHelper.onDocumentReady(() => {
  const allCountDowns = DomHelper.queryAll('.react-count-down')
  allCountDowns.forEach(elt => {
    const endDate = DomHelper.data(elt, 'count-down-end')
    ReactDOM.render(
      <CountDown
        date={new Date(parseFloat(endDate))}
        days={{ plural: 'D ', singular: 'D ' }}
        hours=":"
        mins=":"
        segs=""
      />,
      elt
    )
  })

  const renderRanking = DomHelper.query('#react-render-round-ranking')
  if (renderRanking) {
    ReactDOM.hydrate(
      <RankingTable
        locale={window.initialState.locale.identifierShort}
        ranking={window.initialState.ranking}
        contestSeoName={window.initialState.contestSeoName}
        teamCatches={window.initialState.allCatches}
        round={window.initialState.round}
        scoreLessIsMore={window.initialState.contestScoreLessIsMore}
      />,
      renderRanking
    )
  }
  const renderIndividualRanking = DomHelper.query('#react-render-round-individual-ranking')
  if (renderIndividualRanking) {
    ReactDOM.hydrate(
      <IndividualRankingTable
        locale={window.initialState.locale.identifierShort}
        ranking={window.initialState.ranking}
        contestSeoName={window.initialState.contestSeoName}
        usersCatches={window.initialState.allCatches}
        round={window.initialState.round}
        scoreLessIsMore={window.initialState.contestScoreLessIsMore}
      />,
      renderIndividualRanking
    )
  }
})

if (module.hot) {
  module.hot.accept()
}
